import {dateField, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class SalePeriodData extends EntityData<SalePeriodData> {
    @identifier id: number;
    @field name: string;
    @field code: string;
    @dateField startTime: Date;
}
